import React from "react";

const OrderIcon = () => (
  <svg className="order-icon" x="0px" y="0px" viewBox="0 0 22.034 19.521">
    <g id="Group_82" data-name="Group 82" transform="translate(0.5 0.5)">
      <path
        id="Path_34"
        data-name="Path 34"
        d="M2.264,33.782A2.266,2.266,0,1,0,0,31.514,2.267,2.267,0,0,0,2.264,33.782Zm0-3.479a1.211,1.211,0,1,1-1.211,1.211A1.213,1.213,0,0,1,2.264,30.3Z"
        transform="translate(0 -29.25)"
        strokeWidth="1"
      />
      <path
        id="Path_35"
        data-name="Path 35"
        d="M2.264,196.677A2.264,2.264,0,1,0,0,194.414,2.267,2.267,0,0,0,2.264,196.677Zm0-3.475a1.211,1.211,0,1,1-1.211,1.211A1.213,1.213,0,0,1,2.264,193.2Z"
        transform="translate(0 -185.153)"
        strokeWidth="1"
      />
      <path
        id="Path_36"
        data-name="Path 36"
        d="M2.264,359.577A2.264,2.264,0,1,0,0,357.314,2.267,2.267,0,0,0,2.264,359.577Zm0-3.479a1.211,1.211,0,1,1-1.211,1.211A1.213,1.213,0,0,1,2.264,356.1Z"
        transform="translate(0 -341.056)"
        strokeWidth="1"
      />
      <path
        id="Path_37"
        data-name="Path 37"
        d="M164.128,70.707h12.95a.528.528,0,1,0,0-1.057h-12.95a.528.528,0,1,0,0,1.057Z"
        transform="translate(-156.573 -67.915)"
        strokeWidth="1"
      />
      <path
        id="Path_38"
        data-name="Path 38"
        d="M164.128,233.607h12.95a.528.528,0,1,0,0-1.057h-12.95a.528.528,0,1,0,0,1.057Z"
        transform="translate(-156.573 -223.818)"
        strokeWidth="1"
      />
      <path
        id="Path_39"
        data-name="Path 39"
        d="M164.128,396.407h12.95a.528.528,0,1,0,0-1.057h-12.95a.528.528,0,1,0,0,1.057Z"
        transform="translate(-156.573 -379.625)"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export default OrderIcon;
